var _defs, _rect, _rect2, _rect3, _path, _path2, _text, _text2, _text3, _line, _circle, _line2, _text4, _text5, _text6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGildedArch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 520",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bgArch",
    cx: "50%",
    cy: "0%",
    r: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fdf8ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#f4e9d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ecdcb6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "noise3"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 0.85,
    numOctaves: 2,
    stitchTiles: "stitch"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.045 0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 520,
    fill: "url(#bgArch)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 399,
    height: 519,
    fill: "none",
    stroke: "#d4b888",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 520,
    filter: "url(#noise3)",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 504 L22 160 Q 22 22 200 22 Q 378 22 378 160 L378 504",
    fill: "none",
    stroke: "#b08a4c",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 504 L34 160 Q 34 36 200 36 Q 366 36 366 160 L366 504",
    fill: "none",
    stroke: "#b08a4c",
    strokeWidth: 0.7,
    opacity: 0.6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 200,
    textAnchor: "middle",
    fontFamily: "Allura, cursive",
    fontSize: 58,
    fill: "#6b3a3a"
  }, "Juliet")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 250,
    textAnchor: "middle",
    fontFamily: "Italianno, cursive",
    fontSize: 46,
    fill: "#b08a4c"
  }, "&amp;")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 310,
    textAnchor: "middle",
    fontFamily: "Allura, cursive",
    fontSize: 58,
    fill: "#6b3a3a"
  }, "Romeo")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 340,
    x2: 200,
    y2: 340,
    stroke: "#b08a4c",
    strokeWidth: 0.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 340,
    r: 2.4,
    fill: "#b08a4c"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 340,
    x2: 240,
    y2: 340,
    stroke: "#b08a4c",
    strokeWidth: 0.9
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 372,
    textAnchor: "middle",
    fontFamily: "Cormorant SC, serif",
    fontSize: 11,
    letterSpacing: 3,
    fill: "#5b4a36"
  }, "SATURDAY \xB7 SEPTEMBER TWELFTH")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 394,
    textAnchor: "middle",
    fontFamily: "Cormorant SC, serif",
    fontSize: 10,
    letterSpacing: 3,
    fill: "#5b4a36"
  }, "TWO THOUSAND TWENTY SIX")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 438,
    textAnchor: "middle",
    fontFamily: "Italianno, cursive",
    fontSize: 26,
    fill: "#6b3a3a"
  }, "Join us in our happiness")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGildedArch);
export default __webpack_public_path__ + "static/media/gildedArch.68b2ac708eac986d87c1b855f451b04f.svg";
export { ForwardRef as ReactComponent };